export const getFullUserName = (user) => {
    if (!user)
        return "";
    return `${user.first_name} ${user.last_name}`;
};
//# sourceMappingURL=getFullUserName.js.map